import React, { useState, useMemo, useEffect } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import csc from 'country-state-city'
import {
  userBasicInfoAsync,
  ipAsync,
  phoneEmailOtp,
  verifyPhoneEmailOtp,
  CheckWalletAddress,
} from '../_redux'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import ethereum_address from 'ethereum-address'

import { OtpTimer } from '../../../../_metronic/layout/components/otp-timer'

import './body.scss'

const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/
const addBodyClass = (className) =>
  document.body.classList.add('removeHeaderFooter')
const removeBodyClass = (className) =>
  document.body.classList.remove('removeHeaderFooter')

function BasicInformation(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass('removeHeaderFooter')

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass('removeHeaderFooter')
    }
  }, [props.className])
  const { user, flashMessage, isLoading, seconds, displayTimer } = useSelector(
    (state) => state.auth,
    shallowEqual,
  )

  const [timer, setTimer] = useState(0)

  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState([])
  const [countryCode, setCountryCode] = useState({ country: '', code: '' })

  const [firstName, setFirstName] = useState(user.firstName || '')
  const [lastName, setLastName] = useState(user.lastName || '')
  const [contactNumber, setContactNumber] = useState(user.contactNumber || '')
  const [emailId, setEmailId] = useState(user.emailId || '')
  const [country, setCountry] = useState(user.country || '')
  const [state, setState] = useState(user.state || '')
  const [city, setCity] = useState(user.city || '')
  const [address, setAddress] = useState(user.address || '')
  const [walletAddress, setWalletAddress] = useState('')
  const [showField, setShowField] = useState(
    user.isEmailVerified ? 'email' : 'phone',
  )
  const [showTimer, setShowTimer] = useState(timer)
  const [otp, setOtp] = useState('')
  const [walletAddressValidity, setWalletAddressValidity] = useState(false)

  useEffect(() => {
    if (user.isEmailVerified) {
      setShowField('email')
    }
    if (!user.contactNumber) setCountryCode({ country: 'us', code: '+' + 1 })
  }, [])

  const dispatch = useDispatch()

  // const initialValues = {
  // 	emailId: user.emailId || "",
  // 	contactNumber: user.contactNumber || "",
  // 	firstName: user.firstName || "",
  // 	lastName: user.lastName || "",
  // 	country: user.country || "",
  // 	state: user.state || "",
  // 	city: user.city || "",
  // 	address: user.address || "",
  // 	// bankAccountNumber: "",
  // 	// swiftCode: "",
  // 	walletAddress: user.walletAddress || "",
  // 	showField:  user.isEmailVerified ? "email" : "phone",               //user.emailId ? "phone" : "email",
  // 	otp: "",
  // 	showTimer: timer
  // };

  const initialValues = {
    emailId: emailId || '',
    contactNumber: contactNumber || '',
    firstName: firstName || '',
    lastName: lastName || '',
    country: country || '',
    state: state || '',
    city: city || '',
    address: address || '',
    // bankAccountNumber: "",
    // swiftCode: "",
    walletAddress: walletAddress || '',
    //showField:  isEmailVerified ? "email" : "phone",               //user.emailId ? "phone" : "email",
    otp: '',
    //showTimer: timer
  }

  let allCountriesList = useMemo(() => csc.getAllCountries())

  useEffect(() => {
    if (user.country) {
      setCountry(user.country)
      formik.setFieldValue('country', user.country)

      allCountriesList.map((singleCountry) => {
        if (singleCountry.isoCode === user.country) {
          // set state
          let stateList = csc.getStatesOfCountry(singleCountry.isoCode)
          setStateList(stateList)

          stateList.map((singleState) => {
            if (user.state == singleState.isoCode) {
              //set state
              formik.setFieldValue('state', user.state)
              setState(user.state)

              let cityList = csc.getCitiesOfState(
                singleCountry.isoCode,
                singleState.isoCode,
              )
              setCityList(cityList)

              cityList.map((singleCity) => {
                if (
                  singleCity.countryCode == singleCountry.isoCode &&
                  singleCity.stateCode == singleState.isoCode
                ) {
                  //set city
                  formik.setFieldValue('city', singleCity.name)
                  setCity(user.city)
                }
              })
            }
          })
        }
      })
    }
  }, [])

  const basicInfoSchema = Yup.object().shape({
    emailId: Yup.string()
      .trim()
      .email('Please enter a valid email address')
      .required('Please enter a email'),
    contactNumber: Yup.string()
      .trim()
      .min(10, 'Please enter valid phone number')
      .required('Please enter a phone number'),
    firstName: Yup.string().trim().required('Please enter first name'),
    lastName: Yup.string().trim().required('Please enter last name'),
    state: Yup.string().trim().required('Please select state'),
    city: Yup.string().trim().required('Please select country'),
    address: Yup.string().trim().required('Please enter a address'),
    // swiftCode: Yup.string()
    // 	.trim()
    // 	.required("Please enter swiftcode"),
    // bankAccountNumber: Yup.string()
    // 	.trim()
    // 	.required("Please enter Bank Account Number"),
    walletAddress: Yup.string().trim().required('Please enter Wallet Address'),
  })

  const formik = useFormik({
    initialValues,
    validationSchema: basicInfoSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      dispatch(userBasicInfoAsync(values, user._id))
    },
  })

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }
    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }
    return ''
  }

  const sendOtp = () => {
    console.log(
      firstName,
      lastName,
      emailId,
      contactNumber,
      country,
      state,
      city,
      address,
      walletAddress,
    )

    setTimer(1)

    let body = {
      firstName: firstName,
      lastName: lastName,
      country: country,
      state: state,
      city: city,
      address: address,
      walletAddress: walletAddress,
    }

    formik.setFieldValue('firstName', body.firstName)
    formik.setFieldValue('lastName', body.lastName)
    formik.setFieldValue('country', body.country)
    formik.setFieldValue('state', body.state)
    formik.setFieldValue('city', body.city)
    formik.setFieldValue('address', body.address)
    formik.setFieldValue('walletAddress', body.walletAddress)

    if (showField == 'phone') {
      body = { ...body, emailId: emailId }
      formik.setFieldValue('emailId', emailId)
    } else {
      body = { ...body, contactNumber: contactNumber }
      formik.setFieldValue('contactNumber', contactNumber)
    }
    dispatch(phoneEmailOtp({ body: body, id: user._id }))
  }

  const resendOtp = () => {
    setTimer(1)
    sendOtp()
  }

  const verifyOtp = () => {
    console.log(user)

    if (showField == 'email') {
      let details = {
        contactNumber: '',
        code: '',
      }
      details.contactNumber = formik.getFieldProps('contactNumber').value

      details.code = formik.getFieldProps('otp').value
      console.log(details)
      dispatch(verifyPhoneEmailOtp(details, user._id))
    } else {
      let details = {
        emailId: '',
        code: '',
      }
      details.emailId = formik.getFieldProps('emailId').value
      details.code = formik.getFieldProps('otp').value
      console.log(details)
      dispatch(verifyPhoneEmailOtp(details, user._id))
    }
    console.log(user)
  }

  const onCountryChange = (e) => {
    let country = e.target.value
    let stateList = csc.getStatesOfCountry(country)
    setStateList(stateList)
    //formik.handleChange(e);
    setCountry(e.target.value)
  }

  const onStateChange = (e) => {
    let state = e.target.value

    let cityList

    stateList.map((st) => {
      if (state == st.isoCode) {
        cityList = csc.getCitiesOfState(st.countryCode, st.isoCode)
      }
    })

    setCityList(cityList)
    //formik.handleChange(e);
    setState(e.target.value)
  }

  const onCityChange = (e) => {
    setCity(e.target.value)
  }

  const handleFirstName = (e) => {
    setFirstName(e.target.value)
  }
  const handleLastName = (e) => {
    setLastName(e.target.value)
  }
  const handleEmailId = (e) => {
    setEmailId(e.target.value)
  }
  const handleContactNumber = (e) => {
    console.log(e.target.value)
  }
  const handleAddress = (e) => {
    setAddress(e.target.value)
  }
  const handleWalletAddress = (e) => {
    const newwalletAddress = e.target.value
    console.log(newwalletAddress)
    setWalletAddress(newwalletAddress)

    try {
      if (ethereum_address.isChecksumAddress(newwalletAddress)) {
        setWalletAddressValidity(true)

        let details = {
          walletAddress: '',
        }
        details.walletAddress = e.target.value
        console.log(details)
        const check = dispatch(CheckWalletAddress(details))
        if (!check) {
          setWalletAddress(newwalletAddress)
        }
      } else {
        setWalletAddressValidity(false)
      }
    } catch (e) {
      setWalletAddressValidity(false)
    }

    //setWalletAddress(walletAddress);
  }

  const handleFormValueChange = (e) => {}

  if (user.isProfileSet) {
    return <Redirect to="/login" />
  }

  if (!user.emailId && !user.contactNumber) {
    return <Redirect to="/" />
  }

  return (
    <>
      <div className="inner_main inner_main_v2">
        <div className="row w-100">
          <div className="col-xl-3 d-flex align-items-end justify-content-center d_none_1199">
            <div>
              <img
                alt=""
                className="img-fluid"
                src={toAbsoluteUrl('/media/others/developer-outline.png')}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="row">
              <div className="col-md-12 text-center mt-15 mb-10">
                <img
                  alt="Logo"
                  className="max-h-70px mb-5"
                  src={toAbsoluteUrl('/media/logos/auth_logo.png')}
                />
              </div>
              {flashMessage ? (
                <div
                  className="mb-10 alert alert-custom alert-light-danger alert-dismissible"
                  style={{ margin: 'auto' }}
                >
                  <div className="alert-text font-weight-bold">
                    {flashMessage}
                  </div>
                </div>
              ) : null}
              <div className="col-md-12">
                <div className="wt_box wt_box750 mb-5">
                  <div
                    className="login-form login-signin loader-display-position"
                    id="kt_login_signin_form"
                  >
                    {/* begin::Head */}
                    <div className="text-center mb-10 mb-lg-15">
                      <h3 className="fn_s_32 color_blk f-w-500 mt-3">
                        Basic Information
                      </h3>
                      <p className="opacity60 fn_s_16 color_blk f-w-400">
                        Please enter your basic details.
                      </p>
                    </div>
                    {/* end::Head */}

                    {/*begin::Form*/}
                    <form
                      className="form def_form text-left"
                      onSubmit={formik.handleSubmit}
                    >
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">First Name</label>
                            <input
                              placeholder="Enter your first name"
                              type="text"
                              className={`form-control ${getInputClasses(
                                'firstName',
                              )} password-valid`}
                              name="firstName"
                              {...formik.getFieldProps('firstName')}
                              onChange={handleFirstName}
                              value={firstName}
                            />

                            {formik.touched.firstName && firstName == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.firstName}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">Last Name</label>
                            <input
                              placeholder="Enter your last name"
                              type="text"
                              className={`form-control ${getInputClasses(
                                'lastName',
                              )} password-valid`}
                              name="lastName"
                              {...formik.getFieldProps('lastName')}
                              onChange={handleLastName}
                              value={lastName}
                            />
                            {formik.touched.lastName && lastName == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.lastName}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        {/* show verified field among email and contact BEGINS */}
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">
                              {showField === 'phone'
                                ? 'Contact Number'
                                : 'Email'}
                              {showField === 'email' ? (
                                user.isEmailVerified ? (
                                  <i className="fas fa-check-circle green"></i>
                                ) : user.isPhoneVerified ? (
                                  <i className="fas fa-check-circle green"></i>
                                ) : null
                              ) : user.isEmailVerified ? (
                                <i className="fas fa-check-circle green"></i>
                              ) : user.isPhoneVerified ? (
                                <i className="fas fa-check-circle green"></i>
                              ) : null}
                            </label>
                            {showField === 'phone' ? (
                              <input
                                type="text"
                                className={`form-control ${getInputClasses(
                                  'contactNumber',
                                )} password-valid`}
                                name="contactNumber"
                                value={contactNumber}
                                disabled
                              />
                            ) : (
                              <input
                                type="email"
                                className={`form-control ${getInputClasses(
                                  'emailId',
                                )} password-valid`}
                                name="emailId"
                                value={emailId}
                                disabled
                              />
                            )}
                          </div>
                        </div>
                        {/* show verified field among email and contact ENDS */}

                        {/* <div className="col-md-12">
													<div className="form-group row">
														<label className="form-label col-md-3">
															{showField === "phone"
																? "Email"
																: "Contact Number"}
														</label>
														<div className="col-md-6">

															{showField === "phone" ? (
																<input
																	placeholder="Enter your email"
																	type="email"
																	className={`form-control ${getInputClasses(
																		"emailId"
																	)} password-valid`}
																	name="emailId"
																	{...formik.getFieldProps("emailId")}
																/>
															) : (

																	<PhoneInput
																		inputProps={{
																			name: 'contactNumber',
																		}}
																		countryCodeEditable={false}
																		placeholder="Phone"
																		country={countryCode.country}
																		value={contactNumber}
																		inputClass="dynamic_phoneInput"
																		buttonClass="dynamic_countryDrop"
																		onChange={(phone, data, event) => {
																			formik.setFieldValue('contactNumber', phone)
																		}}
																	/>
																)}
														</div>
														{formik.touched.emailId && formik.errors.emailId ? (
															<div className="fv-plugins-message-container">
																<div className="fv-help-block">
																	{formik.errors.emailId}
																</div>
															</div>
														) : null}
														{formik.touched.contactNumber &&
															formik.errors.contactNumber ? (
																<div className="fv-plugins-message-container">
																	<div className="fv-help-block">
																		{formik.errors.contactNumber}
																	</div>
																</div>
															) : null}
														<div className="col-md-3">
															<button																
																id="kt_login_signin_submit"
																onClick={sendOtp}
																type="button"
																className="btn btn-def defwtarw"
															>
																<span>Send OTP</span>																
															</button>
														</div>


													</div>
												</div>	 */}

                        {/* show UN-VERIFIED  field among email and contact BEGINS */}
                        <div className="col-md-12">
                          <div className="row form-group">
                            <div className="col-md-8">
                              <label className="form-label">
                                {showField === 'phone'
                                  ? 'Email'
                                  : 'Contact Number'}
                                {showField === 'phone' ? (
                                  user.isEmailVerified ? (
                                    <i className="fas fa-check-circle green"></i>
                                  ) : null
                                ) : user.isPhoneVerified ? (
                                  <i className="fas fa-check-circle green"></i>
                                ) : null}
                              </label>

                              {showField === 'phone' ? (
                                <>
                                  <input
                                    placeholder="Enter your email"
                                    type="email"
                                    className={`form-control ${getInputClasses(
                                      'emailId',
                                    )} password-valid`}
                                    name="emailId"
                                    {...formik.getFieldProps('emailId')}
                                    onChange={handleEmailId}
                                    value={emailId}
                                  />
                                  {formik.touched.emailId && emailId == '' ? (
                                    <div className="fv-plugins-message-container">
                                      <div className="fv-help-block">
                                        {formik.errors.emailId}
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              ) : (
                                <>
                                  <PhoneInput
                                    inputProps={{
                                      name: 'contactNumber',
                                    }}
                                    countryCodeEditable={false}
                                    placeholder="Phone"
                                    country={countryCode.country}
                                    value={contactNumber}
                                    inputClass="dynamic_phoneInput"
                                    buttonClass="dynamic_countryDrop"
                                    onChange={(phone, data, event) => {
                                      setContactNumber(phone)
                                      formik.setFieldValue(
                                        'contactNumber',
                                        contactNumber,
                                      )
                                    }}
                                    //onChange={handleContactNumber}
                                    //value={contactNumber}
                                  />
                                  {formik.touched.contactNumber &&
                                  contactNumber == '' ? (
                                    <div className="fv-plugins-message-container">
                                      <div className="fv-help-block">
                                        {formik.errors.contactNumber}
                                      </div>
                                    </div>
                                  ) : null}
                                </>
                              )}
                            </div>

                            <div className="col-md-4">
                              <button
                                id="kt_login_signin_submit"
                                onClick={sendOtp}
                                disabled={displayTimer}
                                type="button"
                                className="btn btn-def defwtarw"
                              >
                                <span>Send OTP</span>
                              </button>
                            </div>
                          </div>
                        </div>
                        {/* show UN-VERIFIED field among email and contact ENDS */}

                        <div className="col-md-12">
                          <div className="row form-group">
                            <div className="col-md-8">
                              <label className="form-label">OTP</label>
                              {user.isPhoneVerified && user.isEmailVerified ? (
                                <i className="fas fa-check-circle green"></i>
                              ) : null}

                              <input
                                placeholder="Enter OTP"
                                type="text"
                                className={`form-control ${getInputClasses(
                                  'contactNumber',
                                )} password-valid`}
                                name="otp"
                                value={otp}
                                {...formik.getFieldProps('otp')}
                              />
                            </div>

                            <div className="col-md-4">
                              <button
                                id="kt_login_signin_submit"
                                onClick={verifyOtp}
                                type="button"
                                className="btn btn-def defwtarw"
                              >
                                <span>verify</span>
                              </button>
                            </div>
                          </div>
                        </div>

                        {showTimer === 1 || displayTimer == true ? (
                          <div className="col-md-12 text-center mt-10 bottom_links">
                            <OtpTimer seconds={seconds} onResend={resendOtp} />
                          </div>
                        ) : null}

                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">Country</label>
                            <select
                              className={`form-control wtblcar password-valid`}
                              name="country"
                              value={country}
                              onChange={onCountryChange}
                              onBlur={formik.handleBlur}
                            >
                              <option value="">Select</option>
                              {allCountriesList.map((country) => (
                                <option
                                  value={country.isoCode}
                                  key={country.isoCode}
                                >
                                  {country.name}
                                </option>
                              ))}
                            </select>
                            {formik.touched.country && country == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.country}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">State</label>
                            <select
                              className={`form-control wtblcar password-valid`}
                              name="state"
                              value={state}
                              onChange={onStateChange}
                              onBlur={formik.handleBlur}
                            >
                              <option>Select</option>
                              {stateList.map((state) => (
                                <option
                                  value={state.isoCode}
                                  key={state.isoCode}
                                >
                                  {state.name}
                                </option>
                              ))}
                            </select>
                            {formik.touched.state && state == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.state}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">City</label>
                            <select
                              className={`form-control wtblcar password-valid`}
                              name="city"
                              value={city}
                              onChange={onCityChange}
                            >
                              <option>Select</option>
                              {cityList.map((city, i) => (
                                <option value={city.name} key={i}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                            {formik.touched.city && city == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.city}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label className="form-label">Address</label>
                            <input
                              placeholder="Enter address"
                              type="text"
                              className={`form-control ${getInputClasses(
                                'address',
                              )} password-valid`}
                              name="address"
                              {...formik.getFieldProps('address')}
                              onChange={handleAddress}
                              value={address}
                            />
                            {formik.touched.address && address == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.address}
                                </div>
                              </div>
                            ) : null}
                          </div>
                        </div>
                        {/* <div className="col-md-6">
													<div className="form-group">
														<label className="form-label">
															Bank Account Number
                            </label>
														<input
															placeholder="Enter account number"
															type="text"
															className={`form-control ${getInputClasses(
																"bankAccountNumber"
															)} password-valid`}
															name="bankAccountNumber"
															{...formik.getFieldProps("bankAccountNumber")}
														/>
														{formik.touched.bankAccountNumber &&
															formik.errors.bankAccountNumber ? (
																<div className="fv-plugins-message-container">
																	<div className="fv-help-block">
																		{formik.errors.bankAccountNumber}
																	</div>
																</div>
															) : null}
													</div>
												</div>
												<div className="col-md-6"> 
													<div className="form-group">
														<label className="form-label">Swift Code</label>
														<input
															placeholder="Enter code"
															type="text"
															className={`form-control ${getInputClasses(
																"swiftCode"
															)} password-valid`}
															name="swiftCode"
															{...formik.getFieldProps("swiftCode")}
														/>
														{formik.touched.swiftCode &&
															formik.errors.swiftCode ? (
																<div className="fv-plugins-message-container">
																	<div className="fv-help-block">
																		{formik.errors.swiftCode}
																	</div>
																</div>
															) : null}
													</div>
												</div>*/}
                        <div className="col-md-12">
                          <div className="form-group">
                            <label className="form-label">Wallet Address</label>
                            {walletAddressValidity ? (
                              <i className="fas fa-check-circle green"></i>
                            ) : formik.touched.walletAddress &&
                              walletAddress.length > 0 ? (
                              <i class="fas fa-exclamation-circle red"></i>
                            ) : null}
                            {console.log(walletAddressValidity)}
                            <input
                              placeholder="Enter an Ethereum wallet address"
                              type="text"
                              className={`form-control wwllt_inpt ${getInputClasses(
                                'walletAddress',
                              )} password-valid`}
                              name="walletAddress"
                              {...formik.getFieldProps('walletAddress')}
                              onChange={handleWalletAddress}
                              value={walletAddress}
                            />
                            {/* <span className="wllt_txt">Metamask Wallet Address</span> */}
                            {formik.touched.walletAddress &&
                            walletAddress == '' ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {formik.errors.walletAddress}
                                </div>
                              </div>
                            ) : formik.touched.walletAddress &&
                              walletAddressValidity === false ? (
                              <div className="fv-plugins-message-container">
                                <div className="fv-help-block">
                                  {'please enter valid Wallet Address'}
                                </div>
                              </div>
                            ) : null}
                            <div className="form-text text-muted">
                              NOTE: The Ethereum wallet address used here must
                              be unique and must not be used by any other user.
                            </div>
                            <div className="text-muted form-text mt-2">
                              Don't have an Ethereum wallet?{' '}
                              <a href="https://metamask.io" target="_blank">
                                Click here
                              </a>{' '}
                              to set one up.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="form-group mb-0 mt-0">
                        <div className="row">
                          <div className="col-md-12 text-center mb-0">
                            <button
                              disabled={isLoading}
                              id="kt_login_signin_submit"
                              type="submit"
                              className="btn btn-def defwtarw"
                            >
                              <span>Continue</span>
                              {isLoading && (
                                <span className="ml-3 spinner spinner-white"></span>
                              )}
                            </button>
                            {/* <Link to="/register-verification" className="btn btn-def defwtarw"><span>Continue</span></Link> */}
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*end::Form*/}
                    {/* {
                                            showLoading &&
                                            <div className="basic-verification-loader">
                                                <CircularProgress />
                                            </div>
                                        } */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-xl-3 d_none_1199">
            <img
              alt=""
              className="img-fluid mt-20"
              src={toAbsoluteUrl('/media/others/support-solid.png')}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default BasicInformation
